import classNames from 'classnames'
import React from 'react'
import styles from './Thumbnail.module.scss'
import type { ThumbnailProps } from './types'
import { ThumbnailRatio, ThumbnailSize } from './types'

const Thumbnail: React.FC<ThumbnailProps> = ({
  size = ThumbnailSize.medium,
  ratio = ThumbnailRatio.ratio4x3,
  className,
  ...props
}: ThumbnailProps) => {
  return (
    <div
      className={classNames(styles['pintxo-thumbnail'], className)}
      data-size={size}
      data-ratio={ratio}
    >
      <img {...props} />
    </div>
  )
}

export default Thumbnail
